/**
 * @module Hero | Product Cards Redesign - Editable
 * @description
 */
import HeroProdcutCardsRedesign from '~/blocks/Heroes/HeroProductCardsRedesign';
import { JsonObject, useMonarchSlotContext } from '@redventures/cohesion-utils-react';
import Defaults from '~/constants/ProductCardRedesignDefaults';
import setHtml from 'ui/js/utils/setHtml';
import { Product } from '~/components/blocks/ProductCards/types';

interface Data extends JsonObject {
  assetName: string;
  heading: string;
  subheading?: string;
  backgroundImage?: string;
  hasCta: boolean;
  hasSecondaryCta: boolean;
  cardsCtaType: string;
  products: Product[];
}

/**
 * @function Component
 * @description
 */
const HeroProductCardsRedesignEditable = () => {
  const { data } = useMonarchSlotContext<Data>()
  const {
    assetName,
    heading,
    subheading,
    backgroundImage,
    hasCta,
    hasSecondaryCta,
    cardsCtaType,
    products
  } = data || { ...Defaults, assetName: 'Hero | Product Cards Redesign - Editable', products: Defaults.productsArray };

  return (
    <HeroProdcutCardsRedesign
      assetName = { assetName }
      heading = { heading }
      subheading = { <span { ...setHtml( subheading ) } /> }
      backgroundImage = { backgroundImage }
      hasCta = { hasCta }
      hasSecondaryCta = { hasSecondaryCta }
      position = 'MONARCH'
      cardsCtaType = { cardsCtaType }
      productsArray = { products }
    />
  );
};

HeroProductCardsRedesignEditable.displayName = 'Hero | Product Cards Redesign - Editable';

export default HeroProductCardsRedesignEditable;
